import { todayFormatted } from "../../../../src/utils/customUtils";

interface LegacyAmenitiesData {
  start_chainage_km?: string;
  start_chainage_m?: string;

  district?: string;
  highway_category?: string;
  khasra_number?: string;
  national_highway_number?: string;
  pincode?: string;
  state?: string;
  village?: string;

  address_1?: string;
  address_2?: string;

  highway_side?: string;

  property_type_name?: string;
  end_chainage_km?: string;
  end_chainage_m?: string;
}

export const generateLegacyConsentText = (
  document_id: number,
  profile: any,
  amenities: LegacyAmenitiesData,
): string => {
  const {
    start_chainage_km,
    start_chainage_m,
    end_chainage_km,
    end_chainage_m,

    property_type_name,

    district,
    khasra_number,
    national_highway_number,
    pincode,
    state,
    village,

    address_1,
    address_2,

    highway_side,
  } = amenities;

  const commonProps = {
    profileName: profile?.name || "-",

    propertyType: property_type_name || "-",

    khasraNumber: khasra_number || "-",

    nationalHighwayNumber: national_highway_number || "-",

    chainage: `${start_chainage_km || "-"}+${start_chainage_m || "-"} to ${end_chainage_km || "-"}+${end_chainage_m || "-"}`,

    highwaySide: highway_side || "-",

    address: `${address_1 || "-"} ${
      address_2 || ""
    } ${village || "-"} ${district || "-"} ${state || "-"}, ${pincode || "-"}`,

    today: todayFormatted || "-",
  };

  switch (document_id) {
    case 53:
    case 48:
      return `FOR NECESSARY FEE FOR THE USE OF NATIONAL HIGHWAY LAND.

I/We, ${commonProps.profileName} owner/ authorised representative of the owner of Khasra No - ${commonProps.khasraNumber} on National Highway – ${commonProps.nationalHighwayNumber} in existing K.M. Chainage - ${commonProps.chainage} (${commonProps.highwaySide}) at ${commonProps.address} do hereby solemnly declare that,

1. I/ We am/ are the legal owner/ authorised representative of the owner of the land and premises abutting to National Highway - ${commonProps.nationalHighwayNumber} for which the access permission is required.
2. The land is free from all encumbrances.
3. I/ We will pay the necessary fee for the use of the national highway land whenever the fee is asked by the Highway Authorities in future.
4. I/ We will construct the approach road at our own cost according to the permission granted by Highway Authorities.

VERIFICATION

The contents of the affidavit/ undertaking are true and correct to the best of my/ our knowledge and nothing material has been concealed by me/us there from.
Verified by me/ us on ${commonProps.today}`;

    case 49:
    case 29:
      return `FOR NECESSARY ALTERATION INCLUDING COMPLETE REMOVAL/SHIFTING OF THE APPROACH ROAD

I/ We, ${commonProps.profileName} owner/ authorised representative of the owner of Khasra No - ${commonProps.khasraNumber} on National Highway - ${commonProps.nationalHighwayNumber} in existing K.M. Chainage - ${commonProps.chainage} (${commonProps.highwaySide}) at ${commonProps.address} do hereby solemnly declare that,

1. I/ We have applied for the access permission from National Highway ${commonProps.nationalHighwayNumber} to our ${commonProps.propertyType} as mentioned above.
2. I/ We will carry out all necessary alteration including complete removal/ shifting of the approach roads at our own cost, if so required by the Ministry, for the development of National Highway or in the interest of safety in this section.

VERIFICATION

The contents of the affidavit/ undertaking are true and correct to the best of my/ our knowledge and nothing material has been concealed by me/ us there from.
Verified by me/ us on ${commonProps.today}`;

    case 30:
    case 50:
      return `FOR FOLLOWING THE GUIDELINES AND NORMS ISSUED BY MINISTRY OF ROAD TRANSPORT & HIGHWAYS

I/ We, ${commonProps.profileName} owner/ authorised representative of the owner of Khasra No - ${commonProps.khasraNumber} on National Highway - ${commonProps.nationalHighwayNumber} in existing K.M. Chainage - ${commonProps.chainage} (${commonProps.highwaySide}) at ${commonProps.address} do hereby solemnly declare that,

I/ We will follow all the guidelines and norms issued by Ministry of Road Transport & Highways vide circular no RW-NH-33032/01/2017-S&R(R) dated 26.06.2020 along with all the related circulars issued till date including Appendix – I of circular no RW-NH-33032/01/2017-S&R(R) dated 26.06.2020.

VERIFICATION

The contents of the affidavit/ undertaking are true and correct to the best of my/ our knowledge and nothing material has been concealed by me/ us there from.
Verified by me/ us on ${commonProps.today}`;

    case 126:
    case 125:
      return `UNDERTAKING FOR DRAINAGE COMPLIANCE

I/ We, ${commonProps.profileName} owner/ authorised representative of the owner of Khasra No - ${commonProps.khasraNumber} on National Highway - ${commonProps.nationalHighwayNumber} in existing K.M. Chainage - ${commonProps.chainage} (${commonProps.highwaySide}) at ${commonProps.address}, do hereby solemnly declare that:

1. The drainage design proposed for the access facility connecting to the National Highway strictly adheres to all standards, specifications, and circulars issued by the Ministry of Road Transport & Highways (MoRTH).
2. Design, construct, and maintain the drainage arrangement for the access road and its interface with the highway in such a manner that surface run-off is properly channeled and does not enter or obstruct the highway drainage network.
3. No flooding, erosion, or weakening of the highway embankment or shoulder shall occur.
4. If any damage, waterlogging, or safety hazard arises due to inadequate drainage, I/We accept full responsibility to rectify the issue at our own cost and to bear any penalties or actions imposed by the competent authority.

VERIFICATION

The contents of the affidavit/ undertaking are true and correct to the best of my/ our knowledge and nothing material has been concealed by me/ us there from.
Verified by me/ us on ${commonProps.today}`;

    case 141:
      return `UNDERTAKING FOR CONSTRUCTION AND OPERATIONAL STATUS

I/ We, ${commonProps.profileName} owner/ authorised representative of the owner of Khasra No - ${commonProps.khasraNumber} on National Highway - ${commonProps.nationalHighwayNumber} in existing K.M. Chainage - ${commonProps.chainage} (${commonProps.highwaySide}) at ${commonProps.address}, do hereby solemnly declare that:

1. The proposed fuel station is neither in operation nor energized as of the date of this undertaking.
2. The construction of the said fuel station has not been commenced.
3. The construction or operational activities shall begin only after obtaining all requisite approvals and permissions from the concerned Highway Authorities and regulatory bodies.
4. Any violation or deviation from the approved norms shall make this undertaking liable for withdrawal of permission and other actions as deemed fit by the competent authority.

VERIFICATION

The contents of the affidavit/ undertaking are true and correct to the best of my/ our knowledge and nothing material has been concealed by me/ us there from.
Verified by me/ us on ${commonProps.today}`;

    case 209:
    case 210:
      return `UNDERTAKING FOR SUBMISSION OF LEGACY / EXISTING APPLICATION ON RAJMARG PRAVESH PORTAL

I/We, ${commonProps.profileName} owner/authorized representative of Owner, hereby declare that the details, documents, drawings, and information submitted on the Rajmarg Pravesh Portal against this existing/legacy application are true and correct to the best of my/our knowledge.

I/We understand that this application is being processed through the Rajmarg Pravesh Portal for further scrutiny, approval, Provisional NOC, Final NOC, renewal, or related actions as per applicable MoRTH/NHAI/NHIDCL guidelines.

I/We further undertake that if any incorrect information, discrepancy, false declaration, or mismatch with the original records is found at any stage in future, the concerned authority may reject or cancel the NOC/approval/permission issued for this application as per applicable Government guidelines.


VERIFICATION

The contents of this undertaking are true and correct to the best of my/our knowledge and nothing material has been concealed therefrom.
Verified by me/ us on ${commonProps.today}`;

    default:
      return "Consent text not available for this document.";
  }
};
